/*eslint react/no-deprecated:0*/
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Paper, List, ListItem, FloatingActionButton, MenuItem, DatePicker, Divider, Checkbox } from 'material-ui';
import { push } from 'react-router-redux';
import FontAwesome from 'react-fontawesome';
import { Row, Col, Container } from 'reactstrap';

import * as mensajesActions from 'modules/mensajes/action';
import * as generalActions from 'modules/general/action';
import { EliminarConfirmacionC } from 'modules/general/component';
import { checkPermissions } from 'core/generalFunctions';

moment.locale('es');
const DateTimeFormat = global.Intl.DateTimeFormat;

@connect(store => ({
  roles: store.getIn(['user', 'roles']),
  mensajesList: store.getIn(['mensajes', 'lista']).reverse(),
  eliminarId: store.getIn(['mensajes', 'eliminarId']),
}))
export default class extends React.Component {
  componentDidMount = () => {
    if (checkPermissions(['admin', 'administrador_mensajes'])) this.props.dispatch(mensajesActions.get(moment().toDate()));
    this.props.dispatch(generalActions.dashboard_changeTitle('MENSAJES'));
  };
  componentDidUpdate = prevProps => {
    const { roles } = this.props;
    if (roles && prevProps.roles && roles.size != prevProps.roles.size && checkPermissions(['admin', 'administrador_mensajes'])) {
      this.props.dispatch(mensajesActions.get(moment().toDate()));
    }
  };
  componentWillUnmount = () => this.props.dispatch(mensajesActions.clear('all'));
  delete = mensajeId => this.props.dispatch(mensajesActions.setState({ eliminarId: mensajeId || false }));
  confirmDelete = () => {
    this.props.dispatch(mensajesActions.deleteMsg(this.props.eliminarId));
    this.delete();
  };
  getMessages = (fecha, all) => {
    this.props.dispatch(mensajesActions.get(fecha, all));
  };
  add = () => this.props.dispatch(push('/dashboard/mensajes/add/new'));
  render() {
    const { mensajesList, eliminarId } = this.props;
    return (
      <Container fluid={true}>
        <Row>
          <Col md={{ size: 10, offset: 1 }}>
            <Paper zDepth={2} className="container">
              <Row>
                <Col md="3">
                  <h5 className="pt-10">Fecha de los mensajes </h5>
                </Col>
                <Col md="5">
                  <DatePicker
                    autoOk
                    name="fecha"
                    locale="es"
                    DateTimeFormat={DateTimeFormat}
                    defaultDate={moment().toDate()}
                    hintText="Fecha de los mensajes"
                    onChange={(val, fecha) => this.getMessages(fecha)}
                  />
                </Col>
                <Col md="3">
                  <Checkbox label="Mostrar todos" onCheck={(event, isInputChecked) => this.getMessages(moment().toDate(), isInputChecked)} className="pt-10" />
                </Col>
                <Col>
                  <Divider />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <List className="noPadding dividerList">
                    {mensajesList.map(mensaje => (
                      <Row key={mensaje.get('id')}>
                        <Col>
                          <ListItem
                            primaryText={`${moment(mensaje.get('fechaEmision')).format('DD/MM/YY HH:mm')}hs`}
                            secondaryText={<p>{mensaje.get('mensaje')}</p>}
                            secondaryTextLines={2}
                            disabled
                            leftIcon={
                              mensaje.get('global') ? (
                                <FontAwesome name="globe" className="blue" />
                              ) : mensaje.get('usuarioId') ? (
                                <FontAwesome name="user" className="blue" />
                              ) : (
                                <FontAwesome name="bus" className="green" />
                              )
                            }
                            rightIconButton={
                              checkPermissions(['admin', 'administrador_paradas']) && (
                                <MenuItem className="textCenter" onTouchTap={() => this.delete(mensaje.get('id'))}>
                                  <FontAwesome name="trash" className="red" />
                                </MenuItem>
                              )
                            }
                          />
                        </Col>
                        <Col>
                          <Divider />
                        </Col>
                      </Row>
                    ))}
                  </List>
                </Col>
              </Row>
            </Paper>
          </Col>
        </Row>
        {checkPermissions(['admin', 'administrador_mensajes']) && (
          <FloatingActionButton className="bottonFlotanteAdd" onTouchTap={this.add}>
            <FontAwesome name="plus" />
          </FloatingActionButton>
        )}
        <EliminarConfirmacionC eliminarId={eliminarId} confirmar={this.confirmDelete} cancelar={this.delete} />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/mensajes/components/listado.js